import * as React from 'react';
import {Component} from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {isNull} from "../../../utils/utils";

function CircularProgressWithLabelHelper(props) {
    return (
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
            <CircularProgress variant="determinate" {...props} sx={{color:props.customColor}}/>
            <Box
                sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    // color="text.secondary"
                }}
            >
                <Typography variant="caption" component="div" color={props.customColor}>
                    {props.customText ? props.customText : `${Math.round(props.value)}%`}
                </Typography>
            </Box>
        </Box>
    );
}

CircularProgressWithLabelHelper.propTypes = {
    /**
     * The value of the progress indicator for the determinate variant.
     * Value between 0 and 100.
     * @default 0
     */
    value: PropTypes.number.isRequired,
};

export default class CircularProgressWithLabel extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        if (isNull(this.props.value))
            return null;
        return <CircularProgressWithLabelHelper {...this.props} />;
    }
}